// extracted by mini-css-extract-plugin
export default {"thankYouContainer":"ThankYou_thankYouContainer__PSG8d","thankYouData":"ThankYou_thankYouData__+QjTc","stepsNav":"ThankYou_stepsNav__YCAiH","thankYou":"ThankYou_thankYou__RYeyy"};